import React, { useRef} from "react";
import ReactToPrint from "react-to-print";
import ComponentToPrint from "./componentToPrint";
import {Link} from "react-router-dom";

export default function PrintComponent({ color, keyWord, bus, setting }) {

    let componentRef = useRef();


    return (
        <>
            <div>
                {/* button to trigger printing of target component */}
                <ReactToPrint
                    trigger={() => <Link className={"btn text-white"}> {" "+keyWord+" "}
                    <i className="bi bi-people"></i> </Link>}
                    content={() => componentRef}
                />

                {/* component to be printed */}
                <div style={{ display: "none" }}>
                    <ComponentToPrint param={setting} keyCity={keyWord} bus={bus} ref={(el) => (componentRef = el)} />
                </div>
            </div>
        </>
    );
}